import { render, staticRenderFns } from "./ItemListDefaultLayout.vue?vue&type=template&id=4868c8d3&scoped=true"
import script from "./ItemListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./ItemListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868c8d3",
  null
  
)

export default component.exports